import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'aggregate',
  name: 'Aggregate',
  category: 'utilities',
  description: 'Combine multiple items into one or group items together',
  icon: 'Layers',
  color: 'cyan',
  version: '1.3.0',
  
  group: ['transform'],
  
  defaults: {
    name: 'Aggregate',
    color: '#06b6d4'
  },
  
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  tags: ['aggregate', 'group', 'combine', 'merge', 'collect', 'sum', 'count', 'average'],

  metadata: {
    documentation: 'https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.aggregate/'
  }
};

export default definition;
